import styled, { css } from 'styled-components';
import {
    Activable,
    ANIMATION_CURVE,
    ANIMATION_DURATION,
    getSpacingToken,
    getTextTokenPreset,
    getToken,
    Position,
    PositionStrict,
    ZIndex,
} from '@optimus-web/common';

export interface TooltipElementProps extends Activable {
    position?: PositionStrict;
}

export const TooltipElement = styled.div<TooltipElementProps>`
    display: block;
    padding: ${getSpacingToken('100')}px;
    pointer-events: none;
    transition: ${ANIMATION_CURVE.default} ${ANIMATION_DURATION.fast}ms transform;
    z-index: ${ZIndex.Highest};
    transform-origin: top;
    transform: scale(0) translateY(-50%);

    ${(props) =>
        props.position === Position.Top &&
        css`
            transform-origin: bottom;
            transform: scale(0) translateY(50%);
        `}

    ${(props) =>
        props.position === Position.Left &&
        css`
            transform-origin: right;
            transform: scale(0) translateX(50%);
        `}

    ${(props) =>
        props.position === Position.Right &&
        css`
            transform-origin: left;
            transform: scale(0) translateX(-50%);
        `}

    ${(props) =>
        props.active &&
        css`
            transform: scale(1);
        `}
`;

export interface ArrowProps extends Activable {
    position?: PositionStrict;
}

export const Arrow = styled.div<ArrowProps>`
    position: absolute;
    box-shadow: ${getToken('shadow200')};

    ${(props) =>
        props.position === Position.Bottom &&
        css`
            top: 0;
            transform: rotate(180deg);
        `}

    ${(props) =>
        props.position === Position.Top &&
        css`
            bottom: 0;
        `}

    ${(props) =>
        props.position === Position.Left &&
        css`
            right: 6px;
            transform: rotate(270deg);
        `}

    ${(props) =>
        props.position === Position.Right &&
        css`
            left: 6px;
            transform: rotate(90deg);
        `}
`;

export const ArrowPath = styled.path`
    fill: ${getToken('backgroundStaticInverse')};
`;

interface TooltipContentElementProps {
    inline?: boolean;
}

export const TooltipContentElement = styled.div<TooltipContentElementProps>`
    background-color: ${getToken('backgroundStaticInverse')};
    border-radius: ${getToken('borderRadius50')}px;
    color: ${getToken('textStaticInverse')};
    ${getTextTokenPreset('bodySmallStrong')};
    text-align: center;
    text-transform: none;
    box-shadow: ${getToken('shadow200')};
    padding: ${getSpacingToken('50')}px ${getSpacingToken('150')}px;
    ${(props) =>
        props.inline &&
        css`
            white-space: nowrap;
        `}
`;
